<template>
  <div>
    <b-card border-variant="danger" v-if="((errore_caricamento) && (Caricato))">
      <h4 class="mt-0 mb-0 text-danger">Errore durante il caricamento delle informazioni iniziali</h4>
      <p>Ti preghiamo di segnalare il problema all'assistenza tecnica AgentScout telefonando al numero +39.055.0981272, grazie</p>
    </b-card>
    <b-card border-variant="danger" v-if="((errore_caricamento_dispute) && (Caricato))">
      <h4 class="mt-0 mb-0 text-danger">Errore durante il controllo di eventuali dispute sulle licenze</h4>
      <p>Ti preghiamo di segnalare il problema all'assistenza tecnica AgentScout telefonando al numero +39.055.0981272, grazie</p>
    </b-card>
    <b-card border-variant="danger" v-if="((errore_caricamento_pagamenti_falliti) && (Caricato))">
      <h4 class="mt-0 mb-0 text-danger">Errore durante il controllo dei rinnovi delle licenze in abbonamento</h4>
      <p>Ti preghiamo di segnalare il problema all'assistenza tecnica AgentScout telefonando al numero +39.055.0981272, grazie</p>
    </b-card>
        
    <div class="text-center my-3" v-if="Caricato == false">
      <b-spinner 
        variant="primary"
        style="width: 4rem; height: 4rem;"
        label="loading"
      />
      <div class="pt-1 text-primary" style="display:block;">Recupero informazione sui suoi contratti,<br />attendere un'istante prego</div>
    </div>

    <div v-if="Caricato">
      <section v-if="this.totalRecords_dispute > 0">
        <b-row>
          <b-col>        
            <b-card class="border-danger">
              <b-card-title class="text-danger" v-if="this.totalRecords_dispute == 1">Si è verificata 1 Disputa su una tua licenza</b-card-title>
              <b-card-title class="text-danger" v-else >Hai {{ this.totalRecords_dispute }} Dispute da risolvere</b-card-title>

              <vue-good-table
              mode="remote"
              ref="table"
              @on-page-change="onPageChange_dispute"
              :totalRows="totalRecords_dispute"
              :rows="rows_dispute"
              :columns="columns_dispute"
              :search-options="{ 
                  enabled: true,
                  externalQuery: searchTerm_dispute }"
              :pagination-options="{
                  enabled: true,
                  perPage:pageLength_dispute
              }"
              >
              
                <template
                    slot="table-row"
                    slot-scope="props"
                >
        
                    <!-- Column: license.price -->
                    <span v-if="props.column.field === 'license.ref_code'">
                      <a @click="$router.push({ name: 'area-clienti-licenze-show', params: { id_riga: props.row.license.id }})">{{ props.formattedRow[props.column.field] }}</a>
                    </span>
                    
                    <!-- Column: license.price -->
                    <span v-else-if="props.column.field === 'license.price'">
                      {{ prezzoFormattatoConIva(props.formattedRow[props.column.field], props.row.license.customer.billing.vat_scheme_id) }}
                    </span>
                    
                    <!-- Column: disputa.id -->
                    <span v-else-if="props.column.field === 'dispute.id'">
                      <b-badge variant="danger" v-if="(props.formattedRow[props.column.field])">
                        Disputa
                      </b-badge>
                      <b-badge variant="success" v-else>Nessuna</b-badge>
                    </span>
        
                    <!-- Column: updated_at -->
                    <div v-else-if="props.column.field === 'updated_at'">
                      {{ formattazioneDataOra(props.row.updated_at, 'it') }}
                    </div>

                    <!-- Column: azioni -->
                    <span v-else-if="props.column.field === 'azioni'">
                      <div class="text-nowrap">
                        <feather-icon
                          icon="ArrowRightIcon"
                          class="cursor-pointer text-primary"
                          size="21"
                          @click="$router.push({ name: 'area-clienti-licenze-disputa', params: { id_riga: props.row.license.id, id_disputa: props.row.dispute.id }})"
                        />
                      </div>
                    </span>
        
                    <!-- Column: standard -->
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
        
                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                    slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap">
                        Visualizzazione da 1 a 
                        </span>
                        <b-form-select
                        v-model="pageLength_dispute"
                        :options="['10','25','50','100']"
                        class="mx-1"
                        @input="(value)=>props.perPageChanged({currentPerPage_dispute:value})"
                        />
                        <span class="text-nowrap "> di {{ props.total_dispute }} righe </span>
                    </div>
                    <div>
                        <b-pagination
                        :value="1"
                        :total-rows="props.total_dispute"
                        :per-page="pageLength_dispute"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                        @input="(value)=>props.pageChanged({currentPage_dispute:value})"
                        >
                        <template #prev-text>
                            <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                            />
                        </template>
                        <template #next-text>
                            <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                            />
                        </template>
                        </b-pagination>
                    </div>
                    </div>
                </template>
              </vue-good-table>

            </b-card>
          </b-col>
        </b-row>
      </section>

      
      <section v-if="this.totalRecords_pagamenti_falliti > 0">
        <b-row>
          <b-col>        
            <b-card class="border-danger">
              <b-card-title class="text-danger" v-if="this.totalRecords_pagamenti_falliti == 1">Si è verificato 1 Pagamento Fallito per una tua licenza</b-card-title>
              <b-card-title class="text-danger" v-else >Hai {{ this.totalRecords_pagamenti_falliti }} Pagamenti Falliti da risolvere</b-card-title>

              <vue-good-table
              mode="remote"
              ref="table"
              @on-page-change="onPageChange_pagamenti_falliti"
              :totalRows="totalRecords_pagamenti_falliti"
              :rows="rows_pagamenti_falliti"
              :columns="columns_pagamenti_falliti"
              :search-options="{ 
                  enabled: true,
                  externalQuery: searchTerm_pagamenti_falliti }"
              :pagination-options="{
                  enabled: true,
                  perPage:pageLength_pagamenti_falliti
              }"
              >
              
                <template
                    slot="table-row"
                    slot-scope="props"
                >
        
                    <!-- Column: license.price -->
                    <span v-if="props.column.field === 'license.ref_code'">
                      <a @click="$router.push({ name: 'area-clienti-licenze-show', params: { id_riga: props.row.license.id }})">{{ props.formattedRow[props.column.field] }}</a>
                    </span>
                    
                    <!-- Column: license.price -->
                    <span v-else-if="props.column.field === 'dati_paymenti_intent.importo'">
                      {{ prezzoFormattato(props.formattedRow[props.column.field]) }}
                    </span>
                    
                    <!-- Column: motivo -->
                    <span v-else-if="props.column.field === 'dati_paymenti_intent.motivo'">
                      <b-badge variant="danger">{{ props.formattedRow[props.column.field] }}</b-badge>
                    </span>
        
                    <!-- Column: updated_at -->
                    <div v-else-if="props.column.field === 'updated_at'">
                      {{ formattazioneDataOra(props.row.updated_at, 'it') }}
                    </div>

                    <!-- Column: azioni -->
                    <span v-else-if="props.column.field === 'azioni'">
                      <div class="text-nowrap">
                        <feather-icon
                          icon="ArrowRightIcon"
                          class="cursor-pointer text-primary"
                          size="21"
                          @click="$router.push({ name: 'area-clienti-licenze-pagamento-fallito', params: { id_riga: props.row.id }})"
                        />
                      </div>
                    </span>
        
                    <!-- Column: standard -->
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
        
                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                    slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap">
                        Visualizzazione da 1 a 
                        </span>
                        <b-form-select
                        v-model="pageLength_pagamenti_falliti"
                        :options="['10','25','50','100']"
                        class="mx-1"
                        @input="(value)=>props.perPageChanged({currentPerPage_pagamenti_falliti:value})"
                        />
                        <span class="text-nowrap "> di {{ props.total_pagamenti_falliti }} righe </span>
                    </div>
                    <div>
                        <b-pagination
                        :value="1"
                        :total-rows="props.total_pagamenti_falliti"
                        :per-page="pageLength_pagamenti_falliti"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                        @input="(value)=>props.pageChanged({currentPage_pagamenti_falliti:value})"
                        >
                        <template #prev-text>
                            <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                            />
                        </template>
                        <template #next-text>
                            <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                            />
                        </template>
                        </b-pagination>
                    </div>
                    </div>
                </template>
              </vue-good-table>

            </b-card>
          </b-col>
        </b-row>
      </section>

      <section v-if="this.totalRecords > 0">
        <b-row>
          <b-col>        
            <b-card>
              <b-card-title v-if="this.totalRecords == 1">Hai 1 Contratto da Accettare</b-card-title>
              <b-card-title v-else >Hai {{ this.totalRecords }} Contratti da Accettare</b-card-title>

              <!-- table -->
              <vue-good-table
              mode="remote"
              ref="table_Licenze_da_Attivare"
              @on-page-change="onPageChange_Licenzedaattivare"
              @on-per-page-change="onPerPageChange_Licenzedaattivare"
              :totalRows="totalRecords"
              :rows="rows"
              :columns="columns"
              :search-options="{ enabled: false, }"
              :pagination-options="{
                  enabled: true,
                  perPage:pageLength
              }"
              >
        
                <template
                    slot="table-row"
                    slot-scope="props"
                >
                    <!-- Column: Price -->
                    <span v-if="props.column.field === 'price'">
                      {{ prezzoFormattato(props.formattedRow[props.column.field]) }}
                    </span>

                    <!-- Column: azioni -->
                    <span v-else-if="props.column.field === 'azioni'">
                      <div class="text-nowrap">
                        <feather-icon
                          icon="ArrowRightIcon"
                          class="cursor-pointer text-primary"
                          size="21"
                          @click="$router.push({ name: 'area-clienti-licenze-show', params: { id_riga: props.row.id }})"
                        />
                      </div>
                    </span>
        
                    <!-- Column: standard -->
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
        
                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                    slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap">
                        Visualizzazione da 1 a 
                        </span>
                        <b-form-select
                        v-model="pageLength"
                        :options="['10','25','50','100']"
                        class="mx-1"
                        @input="(value)=>props.perPageChanged({currentPerPage:value})"
                        />
                        <span class="text-nowrap "> di {{ props.total }} righe </span>
                    </div>
                    <div>
                        <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                        @input="(value)=>props.pageChanged({currentPage:value})"
                        >
                        <template #prev-text>
                            <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                            />
                        </template>
                        <template #next-text>
                            <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                            />
                        </template>
                        </b-pagination>
                    </div>
                    </div>
                </template>
              </vue-good-table>

            </b-card>
          </b-col>
          
        </b-row>
        
      </section>

      <section v-if="this.userData.last_password_update	=== null">
        <b-row>
          <b-col>        
            <b-card>
              <b-card-title>E' necessario aggiornare la tua password di accesso</b-card-title>
              <b-button variant="primary" @click="$router.push({ name: 'area-clienti-profilo-cambio-password' })">Aggiorna Password</b-button>
            </b-card>
          </b-col>
          
        </b-row>
      </section>
    </div>

  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardText, BCardTitle, BFormSelect, BPagination, BSpinner, VBTooltip, BButton, BBadge, } from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { prezzoFormattato, prezzoFormattatoConIva } from '@core/utils/funzioniGlobali'
import moment from 'moment'

export default {
  components: {
    VueGoodTable,
    VBTooltip,
    BRow,
    BCol, 
    BCard, 
    BCardText,
    BCardTitle, 
    BFormSelect,
    BPagination, 
    BSpinner, 
    BButton, 
    BBadge, 

  },
  setup() {
      return {
          prezzoFormattato, 
          prezzoFormattatoConIva, 
      }
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      userData: {},
      
      emptystate: true, 
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Tipo Licenza',
          sortable: false,
          field: 'type',
        },
        {
          label: 'Codice',
          field: 'ref_code',
          sortable: false,
          width: '150px',
        },
        {
          label: 'Importo',
          field: 'price',
          sortable: false,
          width: '150px',
        },

        {
          label: 'Attivazione',
          field: 'azioni',
          sortable: false,
          tdClass: 'text-center',
          width: '150px',
        },
      ],
      rows: [],
      searchTerm: '',
      resetState: 'hidden',
      totalRecords: 0,
      serverParams: {
        columnFilters: {
          "status_id": {"operator": "<=", "value": 26 }, 
          "deleted_at": {"operator": "=", "value": null }
        },
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },

      Caricato: false,
      errore_caricamento: false,

      emptystate_dispute: true, 
      pageLength_dispute: 10,
      dir_dispute: false,
      columns_dispute: [
        {
          label: 'Tipo Licenza',
          field: 'license.type',
          sortable: false,
        },
        {
          label: 'Codice',
          field: 'license.ref_code',
          width: '100px',
          sortable: false,
        },
        {
          label: 'Importo',
          field: 'license.price',
          width: '100px',
          sortable: false,
        },
        {
          label: 'Aggiornato',
          field: 'updated_at',
          width: '140px',
          sortable: false,
        },
        {
          label: 'Dispusta',
          field: 'dispute.id',
          width: '100px',
          html: true,
          sortable: false,
        },

        {
          label: 'Attivazione',
          field: 'azioni',
          sortable: false,
          tdClass: 'text-center',
          width: '150px',
        },
      ],
      rows_dispute: [],
      searchTerm_dispute: '',
      resetState_dispute: 'hidden',
      totalRecords_dispute: 0,
      serverParams_dispute: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      startServerParams_dispute: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      Caricato_dispute: false,
      errore_caricamento_dispute: false,

      emptystate_pagamenti_falliti : true, 
      pageLength_pagamenti_falliti : 10,
      dir_pagamenti_falliti : false,
      columns_pagamenti_falliti : [
        {
          label: 'Tipo Licenza',
          field: 'license.type',
          sortable: false,
        },
        {
          label: 'Codice',
          field: 'license.ref_code',
          width: '100px',
          sortable: false,
        },
        {
          label: 'Importo',
          field: 'dati_paymenti_intent.importo',
          width: '100px',
          sortable: false,
        },
        {
          label: 'Aggiornato',
          field: 'updated_at',
          width: '140px',
          sortable: false,
        },
        {
          label: 'Motivo',
          field: 'dati_paymenti_intent.motivo',
          html: true,
          sortable: false,
        },

        {
          label: 'Attivazione',
          field: 'azioni',
          sortable: false,
          tdClass: 'text-center',
          width: '150px',
        },
      ],
      rows_pagamenti_falliti : [],
      searchTerm_pagamenti_falliti : '',
      resetState_pagamenti_falliti : 'hidden',
      totalRecords_pagamenti_falliti : 0,
      serverParams_pagamenti_falliti : {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'asc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      startServerParams_pagamenti_falliti: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'asc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      Caricato_pagamenti_falliti: false,
      errore_caricamento_pagamenti_falliti: false,

    }
  },
  created() {
    // dati reali
    this.userData = JSON.parse(localStorage.getItem('userData'))
    console.log(this.userData)

    //operazioni iniziali
    this.apertura_pagina();

    
  },
  methods: {
    apertura_pagina(){
      //contratti da accettare
      this.loadItems();

      //controllo ed estrazione eventuali Dispute
      this.controlloDispute();

      //controllo ed estrazione eventuali Pagamenti Falliti
      this.controlloPagamentiFalliti();

      //fine operazioni da eseguire
      this.Caricato = true;      
    },
    formattazioneDataOra(converted_at,lang) {
      if (converted_at) {
        return moment(String(converted_at)).locale(lang).format('DD/MM/YY - HH:mm')
      } else {
        return '---'
      }
    },
    updateParams(newProps) {  
      if (typeof newProps.columnFilters !== 'undefined'){
        //iniettare sempre il filtro per lo status
        newProps.columnFilters.deleted_at = {}
        newProps.columnFilters.deleted_at.operator = '='
        newProps.columnFilters.deleted_at.value = null
      }

      //attiva bottone "reset" filtro o ricerca
      this.resetState = 'attiva';

      this.serverParams = Object.assign({}, this.serverParams, newProps);
      
    },
    
    onPageChange_Licenzedaattivare(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange_Licenzedaattivare(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onPageChange_dispute(params) {
      this.updateParams({page: params.currentPage});
      this.controlloDispute();
    },
    onPerPageChange_dispute(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.controlloDispute();
    },
    
    onPageChange_pagamenti_falliti(params) {
      this.updateParams({page: params.currentPage});
      this.controlloPagamentiFalliti();
    },
    onPerPageChange_pagamenti_falliti(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.controlloPagamentiFalliti();
    },

    loadItems() {
      this.$http.get('api/customer/license/list', {
        params: this.serverParams 
        }).then(response => { 
            if(response.data.statusCode == 200){
              //ok
              this.totalRecords = response.data.reply.meta.total;
              this.rows = response.data.reply.data;
              
            } else if(response.data.statusCode == 422){
              //errori con testo di notifica ok dall'api
              this.$swal({
                title: 'Errore',
                text: 'codice errore: '+response.data.reply,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })

              this.errore_caricamento = true;
            } else {
              //tutto gli altri possibili errori
              this.$swal({
                title: 'Errore Generico',
                text: 'codice errore: '+response.data.statusCode,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
              
              this.errore_caricamento = true;
            }
        
        })

    },

    controlloDispute() {
      this.$http.get('api/customer/license-payment-logs/dispute', {
        params: this.serverParams_dispute 
        }).then(response => { 
            if(response.data.statusCode == 200){
              //ok
              this.totalRecords_dispute = response.data.reply.meta.total;
              this.rows_dispute = response.data.reply.data;
              
            } else if(response.data.statusCode == 422){
              //errori con testo di notifica ok dall'api
              this.$swal({
                title: 'Errore',
                text: 'codice errore: '+response.data.reply,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
              
              this.errore_caricamento_dispute = true;
            } else {
              //tutto gli altri possibili errori
              this.$swal({
                title: 'Errore Generico',
                text: 'codice errore: '+response.data.statusCode,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
              
              this.errore_caricamento_dispute = true;
            }
        
        })

    },

    controlloPagamentiFalliti() {
      this.$http.get('api/customer/license-payment-failed/list', {
        params: this.serverParams_pagamenti_falliti 
        }).then(response => { 
            if(response.data.statusCode == 200){
              //ok
              this.totalRecords_pagamenti_falliti = response.data.reply.meta.total;
              this.rows_pagamenti_falliti = response.data.reply.data;
              
            } else if(response.data.statusCode == 422){
              //errori con testo di notifica ok dall'api
              this.$swal({
                title: 'Errore',
                text: 'codice errore: '+response.data.reply,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
              
              this.errore_caricamento_pagamenti_falliti = true;
            } else {
              //tutto gli altri possibili errori
              this.$swal({
                title: 'Errore Generico',
                text: 'codice errore: '+response.data.statusCode,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
              
              this.errore_caricamento_pagamenti_falliti = true;
            }
        
        })

    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
